<template>
  <div class="warp">
    <el-descriptions class=" wars" title="1.产品信息"   border :column="3"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="产品中文名称">{{application.name}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品中文名称（拼音）：">{{application.namePinyin}}</el-descriptions-item>
      <el-descriptions-item   :span="1"  label="产品英文名称">{{application.nameEnglish}}</el-descriptions-item>
      <el-descriptions-item   :span="3" label="产品类别">{{application.applyType }}</el-descriptions-item>
      <el-descriptions-item   :span="3" v-if="application.otherCategoriesUrl != null" label="产品图片">
        <el-link :underline="false" type="primary" @click="handleDownload(application.otherCategoriesUrl,application.otherCategories)">{{application.otherCategories}}</el-link>
      </el-descriptions-item>
      <el-descriptions-item   :span="3" label="县级以上人民政府建议的地理标志产品保护范围">{{application.originRange}}</el-descriptions-item>
      <el-descriptions-item   :span="3" label="产品描述">{{application.description}}</el-descriptions-item>

      <!-- <el-descriptions-item   :span="3" v-if="application.fileNameCertificateUrl != null" label="产品名称作为商业用语或日常用语长久在先使用证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileNameCertificateUrl,application.fileNameCertificate)">{{application.fileNameCertificate}}</el-link>
      </el-descriptions-item> -->
    </el-descriptions>
    <el-descriptions class=" wars" title="2.申报部门信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border"></el-descriptions>

    <el-descriptions class=" wars" title="申报机构"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="申报机构名称">{{application.applyName}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构联系人">{{application.applyContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构通信地址">{{application.applyAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构传真">{{application.applyFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构电话">{{application.applyPhone}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构电子邮箱">{{application.applyEmail}}</el-descriptions-item>
      <el-descriptions-item  :span="2"  label="当地县级以上人民政府关于成立申报机构或指定协会、企业作为申请人的文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileQualificationUrl,application.fileQualification)">{{application.fileQualification}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="产品所在地知识产权管理部门信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="单位名称">{{application.originName}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位联系人">{{application.originContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位通信地址">{{application.originAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位传真">{{application.originFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电话">{{application.originPhone }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电子邮箱">{{application.originEmail}}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="省级知识产权管理部门信息"  v-if="application.provinceName"  border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="单位名称">{{application.provinceName }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位联系人">{{application.provinceContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位通信地址">{{application.provinceAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位传真">{{application.provinceFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电话">{{application.provincePhone }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电子邮箱">{{application.provinceEmail }}</el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="3.申报材料"   border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  v-if="application.fileApplyUrl != null" label="地理标志产品保护申请书">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileApplyUrl,application.fileApply)">{{application.fileApply}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.fileAddressUrl != null" label="县级以上人民政府界定保护范围的建议的文件">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileAddressUrl,application.fileAddress)">{{application.fileAddress}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1"  v-if="application.fileApplyProtectionUrl != null" label="县级以上人民政府申请保护文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileApplyProtectionUrl,application.fileApplyProtection)">{{application.fileApplyProtection}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1"  label="现行专有标准或技术规范">

        <el-table :data="application.standardDTOs" :cell-style="cellStyles" id="Table" :header-cell-style="headerStyles" border style="width: 100%">
          <el-table-column label="文件名">
            <template v-slot:default="scope">
                <el-link :underline="false" type="primary" @click="handleDownload(scope.row.fileStandardUrl,scope.row.fileStandard)">{{scope.row.fileStandard }}</el-link>

              <!-- <el-button @click="handleFileNameClick(scope.row.fileStandardUrl)">
                {{ scope.row.fileStandard }}
              </el-button>   -->
              <!-- 直接用span并添加点击事件 -->
              <!-- <span @click="handleFileNameClick(scope.row)">{{ scope.row.fileStandard }}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="standardType" label="标准规范类型"></el-table-column>
          <el-table-column prop="standardNum" label="标准规范编号"></el-table-column>
        </el-table>
           <!-- 弹窗显示PDF  暂未使用弹窗 -->
            <el-dialog
              title="查看PDF"
              :visible.sync="dialogVisiblePDF"
              width="80%"
            >
              <iframe :src="currentPdfUrl" width="100%" height="500px"></iframe>
            </el-dialog>


      </el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品检测报告">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTestReportUrl,application.fileTestReport)">{{application.fileTestReport}}</el-link>
      </el-descriptions-item>
      <el-descriptions-item  :span="1"  label="其它证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileOtherUrl,application.fileOther)">{{application.fileOther}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1" v-if="application.fileAwardThatUrl" label="原系统产品获奖证明">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileAwardThatUrl,application.fileAwardThat)">{{application.fileAwardThat}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1" v-if="application.fileClarificationUrl" label="原系统澄清说明">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileClarificationUrl,application.fileClarification)">{{application.fileClarification}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="4.产品情况说明"   border :column="3"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1" v-if="application.historical != null" label="产品历史渊源"><span v-html="application.historical"></span></el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileNameHistoricalUrl != null" label="产品名称历史渊源证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileNameHistoricalUrl,application.fileNameHistorical)">{{application.fileNameHistorical}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.productSell != null" label="产品生产销售"><span v-html="application.productSell"></span></el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileProductSellUrl != null" label="产品生产销售及有关情况">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileProductSellUrl,application.fileProductSell)">{{application.fileProductSell}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.popularity != null" label="产品知名度"><span v-html="application.popularity"></span></el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileProfileUrl != null" label="产品知名度证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileProfileUrl,application.fileProfile)">{{application.fileProfile}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="5.产品质量特色及保护要求"   border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <!-- <el-descriptions-item  :span="1"  label="质量要求"> <span v-html="application.quality"></span></el-descriptions-item> -->
      <!-- <el-descriptions-item  :span="1"  label="产品质量特色与产地自然因素和人文因素的关联性"> <span v-html="application.features"></span></el-descriptions-item> -->
      <!-- <el-descriptions-item  :span="1"  label="专用标志使用与检测机构要求"> <span v-html="application.specialMarks"></span></el-descriptions-item> -->
      <el-descriptions-item  :span="1"  v-if="application.sensoryCharacter != null" label="感官特色"> <span v-html="application.sensoryCharacter"></span></el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.pcIndexes != null" label="理化指标"> <span v-html="application.pcIndexes"></span></el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品保护要求">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileProductProtectionUrl,application.fileProductProtection)">{{application.fileProductProtection}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="6.商标及农产品信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="是否注册商标">{{application.isTrademark == 1 ? "是" : "否"}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标类型">{{application.trademarkType}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标注册证">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTrademarkCardUrl,application.fileTrademarkCard)">{{application.fileTrademarkCard}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标注册证明、在先权利声明文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTrademarkUrl,application.fileTrademark)">{{application.fileTrademark}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  label="是否为农产品">{{application.isAgricultural == 1 ? "是" : "否"}}</el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.isAgricultural == 1" label="农产品证明文件">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileAgriculturalUrl,application.fileAgricultural)"> {{application.fileAgricultural}}</el-link>
      </el-descriptions-item>
    </el-descriptions>






    <el-descriptions v-if="datas.trialFileName!=null" class=" wars" title="初审意见"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.trialResult === 1 ? "通过" : (datas.trialResult === 2 ? "材料补正" : (datas.trialResult === 3 ? "未通过" : ""))}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  :label="datas.trialResult  == 1 ?  '省级知识产权管理部门提交产品保护申请初审意见函' : '初审意见通知书' ">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.trialFileUrl, datas.trialFileName)">{{datas.trialFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>



    <!-- <el-descriptions class=" wars" title="技术审查前提交文件" v-if="datas.evaluationBrforeFileName"  border :column="1"  label-class-name="my-label" content-class-name="my_content_border">

      <el-descriptions-item  :span="1"  label="技术审查申请文件">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationBrforeFileUrl,datas.evaluationBrforeFileName)">{{datas.evaluationBrforeFileName}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="datas.evaluationBeforeResult != null" :label="datas.evaluationBeforeResult==1?'技术审查申请函':'技术审查意见通知书'">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationBeforeResult,datas.evaluationApplyFileName)">{{datas.evaluationApplyFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions> -->


    <el-descriptions class=" wars" title="形式审查"  v-if="datas.formalReviewResult !== null&&datas.formalReviewResult !==''" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.formalReviewResult == 1 ? "通过" : (datas.formalReviewResult == 2 ? "材料补正" : (datas.formalReviewResult ==3? "未通过" : ""))}}</el-descriptions-item>
      <!-- <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item> -->
      <el-descriptions-item  :span="1" v-if="datas.formalReviewResult == 3 || datas.formalReviewResult == 2" label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.formalReviewFileUrl,datas.formalReviewFileName)">{{datas.formalReviewFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>



    <el-descriptions class=" wars" title="形式审查(省确认形式审查补正是否通过)"  v-if="datas.formalReview_ProvinceFileName != null" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">未通过</el-descriptions-item>
      <!-- <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item> -->
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.formalReview_ProvinceFileUrl,datas.formalReview_ProvinceFileName)">{{datas.formalReview_ProvinceFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="技术审查"  v-if="datas.evaluationResult !== null&&datas.evaluationResult !== ''" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.evaluationResult == 1 ? "通过" : (datas.evaluationResult == 2 ? "材料补正" : (datas.evaluationResult ==3? "未通过" : ""))}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.evaluationOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="会议纪要">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationMeetingFileUrl,datas.evaluationMeetingFileName)">{{datas.evaluationMeetingFileName}}</el-link>
      </el-descriptions-item>
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationFileUrl,datas.evaluationFileName)">{{datas.evaluationFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>




    <el-descriptions class=" wars" title="技术审查(省确认技术补正是否通过)"  v-if="datas.evaluation_ProvinceFileName != null" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">未通过</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary"  @click="handleDownload(datas.evaluation_ProvinceFileUrl,datas.evaluation_ProvinceFileName)">{{datas.evaluation_ProvinceFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>














    <el-descriptions class=" wars" title="受理、批准文件"  v-if="datas.acceptName != null" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="受理文件">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.acceptUrl,datas.acceptName)">{{datas.acceptName}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  v-if="datas.approvalName != null" :span="1"  label="批准文件">
        <el-link :underline="false" type="primary"  @click="handleDownload(datas.approvalUrl,datas.approvalName)">{{datas.approvalName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>







    <el-descriptions class=" wars" v-if="datas.objectionsDisallowFileName != null" title="异议驳回"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">异议成立</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="异议审查通知书">
        <el-link :underline="false" type="primary"  @click="handleDownload(datas.objectionsDisallowFileUrl,datas.objectionsDisallowFileName)">{{datas.objectionsDisallowFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>











    <el-descriptions class=" wars"  title=""  border :column="2" direction="vertical" label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item label="异议期信息" :span="1"  >
        <el-button size="mini"  type="primary"  v-if="!isTable" @click="toSeeDetail(1)">查看详情</el-button>
        <el-table :data="yy_tableData" v-else :cell-style="cellStyles" id="Table" :header-cell-style="headerStyles" border style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="content" label="异议内容"></el-table-column>
          <el-table-column prop="createTime" label="异议时间"></el-table-column>
          <el-table-column prop="results" label="处理结果">
            <template slot-scope="scope">
                 {{scope.row.results == 0 ? '未处理' :'已处理'}}
            </template>
          </el-table-column>
          <el-table-column prop="opinion" label="处理意见"></el-table-column>
          <el-table-column prop="opinionFileName" label="处理文件"></el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination layout="prev, pager, next" v-if="yy_total >0" :page-size="limit"   @current-change="yy_handleCurrentChange" :total="yy_total"></el-pagination>
        </div>
      </el-descriptions-item>
    </el-descriptions>


<!-- 申请端不显示专家评审 -->
    <!-- <el-descriptions class=" wars"  title=""  border :column="2" direction="vertical" label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item label="专家评审" :span="1"  >
        <el-button size="mini"  type="primary"  v-if="!isTable_zj" @click="toSeeDetail(2)">查看详情</el-button>
        <el-table :data="zj_tableData" v-else :cell-style="cellStyles" id="Table" :header-cell-style="headerStyles" border style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="expertName" label="专家账号"></el-table-column>
          <el-table-column prop="level" label="评审等级"></el-table-column>
          <el-table-column prop="nameAndToUse" label="产品名称及使用"></el-table-column>
          <el-table-column prop="feature" label="产品特色"></el-table-column>
          <el-table-column prop="relevance" label="产品特色与当地自然地理因素和人文因素的关联性"></el-table-column>
          <el-table-column prop="protectForm" label="申报产品的保护形态"></el-table-column>
          <el-table-column prop="quality" label="质量要求"></el-table-column>
          <el-table-column prop="scope" label="产品及名称的声誉（知名度）（影响范围）"></el-table-column>
          <el-table-column prop="scopeInfluence" label="产品及名称的声誉（知名度）（对应上述影响范围的影响力）"></el-table-column>
          <el-table-column prop="history" label="产品历史渊源"></el-table-column>
          <el-table-column prop="priorRights" label="在先权（普通商标/证明商标）"></el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination layout="prev, pager, next" v-if="zj_total >0" :page-size="limit"   @current-change="zj_handleCurrentChange" :total="zj_total"></el-pagination>
        </div>
      </el-descriptions-item>
    </el-descriptions> -->







    <el-descriptions class=" wars"  title=""  border :column="2" direction="vertical" label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item label="补正记录信息" :span="1"  >
        <el-button size="mini"  type="primary"  v-if="!isTable_bz" @click="toSeeDetail(3)">查看详情</el-button>
        <el-table :data="bz_tableData" v-else :cell-style="cellStyles" id="Table" :header-cell-style="headerStyles" border style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="recordTime" label="修改时间"></el-table-column>
          <el-table-column prop="state" label="所在阶段"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" >
              <el-button type="warning"   size="mini" @click="toSeeDetails1(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>




    <div class="btns" style="width: 100%;height: 5rem;margin-top: 1.5rem">
      <el-button  v-if="datas.therePermission" type="warning" @click="toExamine">审核</el-button>
      <el-button type="success" @click="goBack">返回</el-button>
    </div>

    <!-- 审查-->
    <el-dialog :visible.sync="dialogVisible" width="30%" >

      <el-form :inline="true" :model="forme" class="demo-form-inline" label-width="120px">
        <el-form-item label="审查结果" prop="userName">
          <el-select  placeholder="请选择" v-model="forme.results" clearable value-key="value" class="width1" size="mini">
            <el-option v-for="item in papersOption"  :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="形式审查意见" prop="userName" v-if="forme.results == 2 || forme.results == 3">
          <el-input size="mini" placeholder="输入审查意见" v-model = "forme.opinion"></el-input>
        </el-form-item>

        <el-form-item label="意见通知书" prop="userName" >
          <el-upload
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :file-list="fileList">
            <el-button slot="trigger"  size="mini" type="primary">点击上传附件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submit1">提交</el-button>
  </span>
    </el-dialog>
    <!-- 补正列表-- 详情-->
    <el-dialog :visible.sync="bzdialogVisible" width="70%" >
      <bzDetails  :application="applicationBz" :datas="datasBz" ></bzDetails>
    </el-dialog>
  </div>
</template>

<script>
// import {
//   detailexpertopinion,
//   objectionlist,
//   record1,
//   recordinfo,
//   todoformalexam,
//   toseeDetails,downloadExamFile
// } from "../../api/agencyService";
import {toseeDetails, downloadExamFile,record1,recordinfo,objectionlist} from "../../api/home";


import bzDetails from "./bzDetails.vue";
import {downloadFiles} from "../../../comm/utils/download";
export default {
  name: "details",
  components:{
    bzDetails
  },
  data(){
    return{
      bzId:'',
      datasBz:{},
      applicationBz:{},
      bzapplication:{},
      yy_total:0,
      zj_total:0,
      bz_total:0,
      yy_page:1,
      zj_page:1,
      bz_page:1,
      limit:10,

      dialogVisiblePDF: false,  //弹出查看pdf对话框
      currentPdfUrl: '', //pdf地址

      dialogVisible:false,
      bzdialogVisible:false,
      isTable:false,
      isTable_zj:false,
      isTable_bz:false,
      applyId:'',
      fileList:[],
      datas:{},
      application:{},
      forme:{},
      yy_tableData:[],
      zj_tableData:[],
      bz_tableData:[],
      papersOption:[
        {value:1, label:'通过'},
        {value:2, label:'补正材料'},
        {value:3, label:'不通过'}
      ],
      headerStyles:
        {
          color:'#333',
          padding: '0.375rem',
          'border-right': '2px solid #ffffff',
          'text-align': 'center',
          background: '#eff5fA'
        },
      cellStyles: {'text-align': 'center'},
    }
  },
  created() {
    // this.applyId = this.$route.query.applyId || sessionStorage.getItem('applyId')
    // if (this.applyId){
    //   sessionStorage.setItem('applyId',this.applyId )
    // }

  },
  mounted() {
    this.applyId = this.$route.query.applyId || sessionStorage.getItem('applyId')
    if (this.applyId){
      sessionStorage.setItem('applyId',this.applyId )
    }
    this.getData()
  },


  methods:{
    //查看pdf
    handleFileNameClick(val) {

      this.dialogVisiblePDF = true;
      this.currentPdfUrl = process.env.VUE_APP_FILE_SERVER_URL+'/'+val; // 假设你的数据对象中包含了fileUrl属性
      console.log("pdf的图片地址是：",this.currentPdfUrl)
    },





   //获取详细信息
    getData(){

      toseeDetails(this.applyId).then(res=>{
        if (res.errorCode == 200 ){
          this.application = res.data.application
          this.datas = res.data
        }
      })
    },

    //审核
    toExamine(){

      this.dialogVisible = true

    },



    //文件下载
    handleDownload(url,fileName){
      downloadExamFile({filePath:url, fileName:fileName}).then(response =>{
        downloadFiles(response,fileName)
      })
    },
    //返回
    goBack(){
      this.$router.go(-1)

    },

    //提交审核
    submit1(){
      let params = {
        applyId:this.application.id,
        results:this.forme.results,
        opinion:this.forme.opinion,
        applyVersion:this.application.version,
        applicationNumber:this.application.applicationNumber,
      }
      todoformalexam(this.formData,params).then(res=>{
        if (res.errorCode == 200){
          this.dialogVisible1 = false
          this.$message.success('提交成功')
          this.goBack()

        }else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    //查看详情--异议
    toSeeDetail(index){
      if (index == 1){  //-异议
        this.yy_getDatas()
        this.isTable = true
      }

      if (index == 2){  //-专家
        this.isTable_zj = true
        this.zj_getDatas()

      }
      if (index == 3){  //-专家
        this.isTable_bz = true
        this.bz_getDatas()

      }

    },

    //补正列表---详情
    toSeeDetails1(row){
      this.bzdialogVisible = true
      this.getData2(row.id)


    },

    getData2(bzId){
      recordinfo(bzId).then(res=>{
        if (res.errorCode == 200){
          this.applicationBz = res.data.application
          this.datasBz = res.data


        }else {
          this.$message.error(res.errorMsg)
        }

      })
    },


    //获取异议列表
    yy_getDatas(){


      objectionlist({page:this.yy_page,limit:this.limit},this.application.id).then(res=>{
        if (res.errorCode == 200){
          this.yy_tableData = res.data.data
          this.yy_total = res.data.count

        }else {
          this.$message.error(res.errorMsg)
        }

      })
    },

    //专家评审列表
    zj_getDatas(){

      detailexpertopinion({page:this.yy_page,limit:this.limit},{applyId:this.application.id,applyVersion:this.application.version}).then(res=>{
        if (res.errorCode == 200){
          this.zj_tableData = res.data.data
          this.zj_total = res.data.count

        }else {
          this.$message.error(res.errorMsg)
        }

      })

    },
   //补正列表
    bz_getDatas(){
      record1({page:this.yy_page,limit:this.limit},this.application.id).then(res=>{
        if (res.errorCode == 200){
          this.bz_tableData = res.data
        }else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    yy_handleCurrentChange(pageIndex){
      this.yy_page = pageIndex;
      this.yy_getDatas()
    },

    zj_handleCurrentChange(){
      this.zj_page = pageIndex;
      this.zj_getDatas()
    },
    bz_handleCurrentChange(){
      this.bz_page = pageIndex;
      this.bz_getDatas()
    },
    handleChange (file, fileList) {
      this.formData = new FormData()
      this.formData.append('file', file.raw)
    },
    handleSuccess() {
      this.$refs.upload.clearFiles();
    },

  }
}
</script>

<style scoped lang="less">
 .warp{
   width: 96%;
   margin-left: 2%;
   position: relative;
 }

 .wars{
   margin-bottom: 1.5rem;
 }
 .descriptions-item-content {
  min-width: 100px; /* 你可以根据需要调整这个值 */
  display: inline-block; /* 确保span元素拥有块级元素的特性 */
}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/applicationQuery/details.vue